import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useStore } from "../context/StoreContext";

const LINKS = [
  { label: "Shop", to: "/shop" },
  { label: "Matching Sets", to: "/shop?collection=Matching%20Sets" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export function Navbar() {
  const { cartCount, setCartOpen } = useStore();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll(); window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc]);

  return (
    <header className={`sticky top-0 z-50 transition-colors duration-300 ${scrolled ? "bg-bone/90 backdrop-blur-md border-b border-black/5" : "bg-transparent"}`}
      data-testid="site-navbar">
      <div className="bg-charcoal text-bone text-center py-2 overline text-[10px]" data-testid="announcement-bar">
        SV ATHLETIC WEAR · CONCEPT COLLECTION PREVIEW
      </div>
      <nav className="container-luxe flex items-center justify-between py-5">
        <div className="hidden lg:flex items-center gap-7 flex-1">
          {LINKS.slice(0, 3).map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="font-display text-[11px] tracking-wide2 uppercase link-underline">{l.label}</Link>
          ))}
        </div>
        <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="mobile-menu-open" aria-label="Open menu"><Menu size={22} strokeWidth={1.4} /></button>

        <Link to="/" className="flex-1 flex justify-center" data-testid="nav-logo" aria-label="SV Athletic Wear home">
          <img src="/brand/sv-lockup.png" alt="SV Athletic Wear" className="h-12 sm:h-14 w-auto object-contain" />
        </Link>

        <div className="flex items-center gap-4 lg:gap-5 flex-1 justify-end">
          <div className="hidden lg:flex items-center gap-7 mr-3">
            {LINKS.slice(3).map((l) => (
              <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
                className="font-display text-[11px] tracking-wide2 uppercase link-underline">{l.label}</Link>
            ))}
          </div>
          <button onClick={() => setCartOpen(true)} className="relative" data-testid="nav-cart" aria-label="Cart">
            <ShoppingBag size={19} strokeWidth={1.4} />
            {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-charcoal text-bone text-[9px] h-4 w-4 flex items-center justify-center rounded-full">{cartCount}</span>}
          </button>
        </div>
      </nav>

      {open && (
        <div className="fixed inset-0 z-50 bg-bone lg:hidden" data-testid="mobile-menu">
          <div className="flex items-center justify-between px-6 py-5 border-b border-hairline">
            <img src="/brand/sv-mono.png" alt="SV Athletic Wear" className="h-11 w-auto object-contain" />
            <button onClick={() => setOpen(false)} data-testid="mobile-menu-close" aria-label="Close menu"><X size={24} strokeWidth={1.4} /></button>
          </div>
          <div className="flex flex-col px-6 py-8 gap-6">
            {LINKS.map((l) => (
              <Link key={l.label} to={l.to} className="font-serif text-3xl" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}>{l.label}</Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
